import React from 'react';

import { cn } from '~/utils/cnTailwind';

type Props = {
    className?: string;
    children: React.ReactNode;
    onClick?: React.MouseEventHandler<HTMLTableCellElement>;
};

/** Cell of the redesigned offer management table. */
export const OfferTableCell: React.FC<Props> = ({ children, className, onClick }) => {
    return (
        <td className={cn('text-14 text-left text-midnight whitespace-nowrap px-4 py-3', className)} onClick={onClick}>
            {children}
        </td>
    );
};
